import Nav from './components/Nav.jsx';
import Chrome from './components/Chrome.jsx';
import Hero from './components/Hero.jsx';
import About from './components/About.jsx';
import Skills from './components/Skills.jsx';
import Audits from './components/Audits.jsx';
import Passions from './components/Passions.jsx';
import Contact from './components/Contact.jsx';
import Footer from './components/Footer.jsx';
import { useTheme } from './hooks/useTheme.js';

export default function App() {
  const { theme, toggle } = useTheme();

  return (
    <>
      <Chrome />
      <Nav theme={theme} onToggleTheme={toggle} />

      <main id="main" tabIndex={-1}>
        <Hero />
        <About />
        <Skills />
        <Audits />
        <Passions />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
